import {RDX_NTF_ADD, RDX_NTF_REMOVE, RDX_NTF_RESET } from './notifyAction';
import ObjectHelper from 'approot/common/lib/ObjectHelper';

const initial = {
	default: []
};

const notify = (state = initial, action) => {
	let newState = {...state};
	switch (action.type) {
		case RDX_NTF_ADD:
			if (action.ns) {
				if (!newState[action.ns]) {
					newState[action.ns] = [];
				}
				newState[action.ns] = newState[action.ns].concat(action.msg);
			} else {
				if (!newState.default) {
					newState.default = [];
				}
				if(ObjectHelper.isNullOrlengthZore(newState.default)){
					newState.default = newState.default.concat(action.msg);

				}else if(!ObjectHelper.isNullOrlengthZore(newState.default)) {
					newState.default.forEach(msgObj =>{
						if(msgObj.code !== action.msg.code){
							newState.default = newState.default.concat(action.msg);
						}
					});
				}		
			}
			return newState;
		case RDX_NTF_REMOVE:
			delete newState[action.ns];
			return newState;
		case RDX_NTF_RESET:
			return initial;
		default:
			return state;
	}
};

export default notify;